import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import EditImage from "../../assets/images/edit.png";
import DeleteImage from "../../assets/images/delete.png";
import { userMaster, deleteUser } from '../../services/apiService';
import Loader from '../Loader/Loader';
import Pagination from '../pages/Pagination'; // Import Pagination component

const UserMaster = () => {
  const navigate = useNavigate();
  const [newUserData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchTableData = async () => {
    try {
      setLoading(true);
      const response = await userMaster();
      setUserData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching User data:', error);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const handleEditUser = async (userId) => {
    try {
      navigate(`/edit-user/${userId}`);
    } catch (error) {
      console.error('Error fetching user data for editing:', error);
    }
  };

  const handleDeleteUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this user?");
    if (confirmDelete) {
      try {
        setLoading(true);
        await deleteUser(userId);
        fetchTableData();
        setLoading(false);
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  // Get current users based on pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = newUserData.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Header />
      <div className="container">
        <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
          </ol>
        </nav>
      </div>
      <div className="container pb-4">
        {loading ? (
          <Loader /> // Show the loader while data is loading
        ) : (
          <div className="box-bdr-dash">
            <div className="row">
              <div className="col-md-12">
                <div className="box mb-2">
                  <div className="box-top-title fhir-title">
                    <span className="pd-overview-count">All Users</span>
                    <div className="plus-link plus-btn">
                      <Link to="/create-user">
                        <i className="fa fa-plus"></i> New User
                      </Link>
                    </div>
                  </div>
                  <div className="table-data-box">
                    <table className="table-content borderd-table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.length > 0 ? (
                          currentUsers.map((item, index) => (
                            <tr key={index}>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>{item.last_name}</td>
                              <td>{item.email}</td>
                              <td>{item.phone}</td>
                              <td>
                                <span className="edit-row cursor" onClick={() => handleEditUser(item.id)}>
                                  <img src={EditImage} alt="Edit" />
                                </span>{" "}
                                <span className="delete-row cursor" onClick={() => handleDeleteUser(item.id)}>
                                  <img src={DeleteImage} alt="Delete" />
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6">No users found.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <Pagination
                      itemsPerPage={itemsPerPage}
                      totalItems={newUserData.length}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserMaster;
